

import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'

import MineDebatesTab from './MineDebatesTab'
import MineDisputedTab from './MineDisputedTab'
import VoteQuestion from '../../../Quizzes/VoteQuestion'
import MineLikesTab from './MineLikesTab'

class MineTab extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      tabIndex: 0,
    }
  }

  componentDidMount() {
    const { getOwnQuestions, isTutorial } = this.props
    !isTutorial && getOwnQuestions()
  }

  componentWillUnmount() {
    const { setVoteQuestion } = this.props

    setVoteQuestion(null)
  }

  selectTab(tabIndex) {
    const { addHowlSound, setVoteQuestion } = this.props
    addHowlSound('button_click')
    setVoteQuestion(null)

    this.setState({
      tabIndex: tabIndex,
    })
    return true
  }

  renderReal() {
    const {
      ownQuestions,
      votedQuestion,
      setVoteQuestion,
      disputedQuestions,
      debatedQuestions,
      totalLikes,
      user,
    } = this.props
    let totalDebateWinCoins = 0
    let totalDebateWinAnti = 0
    let totalDisputeWinCoins = 0
    let totalDisputeWinAnti = 0

    const empty =
      (disputedQuestions.length == 0 && this.state.tabIndex == 0) ||
      (debatedQuestions.length == 0 && this.state.tabIndex == 1) ||
      (ownQuestions.length == 0 && this.state.tabIndex == 2)
    debatedQuestions.map((q) => {
      if (q.currency2) {
        q.currency2 == 'antimatter'
          ? (totalDebateWinAnti += q.reward)
          : (totalDebateWinCoins += q.reward)
      }
      q.currency == 'antimatter'
        ? (totalDebateWinAnti += q.reward)
        : (totalDebateWinCoins += q.reward)
    })
    disputedQuestions.map((q) => {
      if (q.currency2) {
        q.currency2 == 'antimatter'
          ? (totalDisputeWinAnti += q.reward)
          : (totalDisputeWinCoins += q.reward)
      }
      q.currency == 'antimatter'
        ? (totalDisputeWinAnti += q.reward)
        : (totalDisputeWinCoins += q.reward)
    })

    console.log(disputedQuestions, debatedQuestions)

    return (
      <Tabs
        className="mars--challenges__info"
        selectedTabClassName="active2"
        selectedIndex={this.state.tabIndex}
        onSelect={(tabIndex) => this.selectTab(tabIndex)}
      >
        <TabList className="mars--challenges__nav">
          <Tab
            className={
              this.state.tabIndex === 0
                ? 'mars--challenges__nav--item active'
                : 'mars--challenges__nav--item'
            }
          >
            <span className="text">
              <FormattedMessage id="phase.mineTab.debates.title" />
            </span>
            <div className="mars--challenges__values">
              <span className={`value ${totalDebateWinCoins < 0 && 'failed'}`}>
                {totalDebateWinCoins} <span className="icon-gcoins" />
              </span>
              <span className={`value ${totalDebateWinAnti < 0 && 'failed'}`}>
                {totalDebateWinAnti} <span className="icon-antimateria-medium" />
              </span>
            </div>
          </Tab>
          <Tab
            className={
              this.state.tabIndex === 1
                ? 'mars--challenges__nav--item active'
                : 'mars--challenges__nav--item'
            }
          >
            <span className="text">
              <FormattedMessage id="phase.mineTab.disputes.title" />
            </span>
            <div className="mars--challenges__values">
              <span className={`value ${totalDisputeWinCoins < 0 && 'failed'}`}>
                {totalDisputeWinCoins} <span className="icon-gcoins" />
              </span>
              <span className={`value ${totalDisputeWinAnti < 0 && 'failed'}`}>
                {totalDisputeWinAnti} <span className="icon-antimateria-medium" />
              </span>
            </div>
          </Tab>
          <Tab
            className={
              this.state.tabIndex === 2
                ? 'mars--challenges__nav--item active'
                : 'mars--challenges__nav--item'
            }
          >
            <span className="text">
              <FormattedMessage id="phase.mineTab.likes.title" />
            </span>
            <div className="mars--challenges__values">
              <span className="value">
                <span className="icon-like" />
                {totalLikes}
              </span>
            </div>
          </Tab>
        </TabList>

        <div className={`mars--challenges__info--content ${empty ? 'void' : ''}`}>
          <TabPanel style={{ width: '100%' }}>
            {!votedQuestion ? (
              <MineDebatesTab
                setVoteQuestion={(question) => setVoteQuestion(question)}
                debatesInfo={debatedQuestions}
              />
            ) : (
              <VoteQuestion />
            )}
          </TabPanel>
          <TabPanel style={{ width: '100%' }}>
            {!votedQuestion ? (
              <MineDisputedTab
                user={user}
                disputedInfo={disputedQuestions}
                setVoteQuestion={(question) => setVoteQuestion(question)}
                debatesInfo={debatedQuestions}
              />
            ) : (
              <VoteQuestion />
            )}
          </TabPanel>
          <TabPanel style={{ width: '100%' }}>
            <MineLikesTab ownQuestions={ownQuestions} />
          </TabPanel>
        </div>
      </Tabs>
    )
  }

  render() {
    return (
      <div className="mars--content challenges--info">
        {/* {this.renderMock()} */}

        {this.renderReal()}
      </div>
    )
  }
}

MineTab.propTypes = {
  addHowlSound: PropTypes.func,
  ownQuestions: PropTypes.array,
  disputedQuestions: PropTypes.array,
  setVoteQuestion: PropTypes.func,
  debatedQuestions: PropTypes.array,
  getOwnQuestions: PropTypes.func,
  totalLikes: PropTypes.number,
  user: PropTypes.object,
  votedQuestion: PropTypes.object,
  isTutorial: PropTypes.bool,
}

export default MineTab
